import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Button from 'material-ui/Button'
import {ListItem, ListItemText, ListItemSecondaryAction} from 'material-ui/List'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import Dialog, {DialogActions, DialogContent, DialogContentText, DialogTitle} from 'material-ui/Dialog'
import Select from 'material-ui/Select'
import {MenuItem} from 'material-ui/Menu'
import Typography from 'material-ui/Typography'
import {Panel, PanelItem, Link} from '../../../components'
import NoCards from './NoCards'
import {paymentMethod as text} from '../text'
import Grid from '../../../common/components/Grid'
import {
  CardIcon,
  CardNumberInput,
  CardExpiryInput,
  CardCVCInput,
  CardholderNameInput,
  DocumentTypeSelector,
  DocumentNumberInput,
} from '../../../common/components/CreditCardInput'
import LoadingButton from '../../../common/components/LoadingButton'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'

import {paymentMethod as styles} from '../styles'

class PaymentMethod extends React.Component {

  state = {
    type: null,
    selected: {
      ID: 0,
      LastDigits: '',
      Type: '',
    },
  }

  handleNumberChange = (value, type) => {
    this.setState({type})
    this.props.setCardNumber(value)
  }

  handleExpiryChange = (month, year) => {
    this.props.setExpiry(month + ' / ' + year)
  }

  handleCVVChange = cvc => {
    this.props.setCVC(cvc)
  }

  handleNameChange = name => {
    this.props.setCardholderName(name)
  }

  handleDocumentTypeChange = name => {
    this.props.setDocumentType(name)
  }

  handleDocumentNumberChange = name => {
    this.props.setDocumentNumber(name)
  }

  handleRemove = card => {
    this.setState({
      selected: {
        ID: card.ID,
        LastDigits: card.LastDigits,
        Type: card.Type,
      },
    })
    this.props.remove()
  }

  renderItemText = (digits, type) => {
    const renderDigits = lastFour => `•••• •••• •••• ${lastFour}`
    return (
      <span>{renderDigits(digits)} ({type})</span>
    )
  }

  renderMainCardText = mark => (
    <span>
      {text.mainCardText}
      (<span style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={mark}>{text.mainCardAction}</span>)
    </span>
  )

  render() {
    const {classes, cards, isFetching, isSaving, error, addDialogShow, removeDialogShow, markDialogShow} = this.props
    if (error !== '') return <ErrorMessage error={error}/>
    if (isFetching === true) return <HeaderProgress show={true}/>
    return (
      <div className={classes.container}>
        {cards.length === 0
          ? <NoCards addCard={this.props.add}/>
          : (
            <div>
              <Panel>
                {cards.map(c => (
                  <PanelItem key={c.ID} dense>
                    <CardIcon type={c.Type} style={{width: 36, height: 36}}/>
                    <div className={classes.textContainer}>
                      <Typography variant={'body1'}
                                  color={'textSecondary'}>{this.renderItemText(c.LastDigits, c.Type)}</Typography>
                      <Typography variant={'body1'}
                                  color={'textSecondary'}>{text.expiryDate}: {c.Expiration}</Typography>
                      <Typography variant={'body1'}
                                  color={'textSecondary'}>{c.Main ? this.renderMainCardText(this.props.mark) : ''}</Typography>
                    </div>
                    <ListItemSecondaryAction>
                      <IconButton onClick={() => this.handleRemove(c)}><ClearIcon/></IconButton>
                    </ListItemSecondaryAction>
                  </PanelItem>
                ))}
              </Panel>
              <div className={classes.linkContainer}>
                <Link onClick={this.props.add}>{text.add}</Link>
              </div>
            </div>
          )}
        <AddDialog
          show={addDialogShow}
          closeDialog={this.props.closeAddDialog}
          handleNumberChange={this.handleNumberChange}
          handleExpiryChange={this.handleExpiryChange}
          handleCVVChange={this.handleCVVChange}
          handleNameChange={this.handleNameChange}
          handleDocumentTypeChange={this.handleDocumentTypeChange}
          handleDocumentNumberChange={this.handleDocumentNumberChange}
          documentTypes={this.props.documentTypes}
          isSaving={isSaving}
          saveAdd={this.props.saveAdd}
          type={this.state.type}
        />
        <RemoveDialog
          show={removeDialogShow}
          closeDialog={this.props.closeRemoveDialog}
          selected={this.state.selected}
          isSaving={isSaving}
          saveRemove={this.props.saveRemove}
        />
        <MarkCardAsMainDialog
          show={markDialogShow}
          closeDialog={this.props.closeMarkDialog}
          initial={function() {
            const main = cards.find(c => c.Main === true)
            return main ? main.ID : 0
          }()}
          cards={cards}
          isSaving={isSaving}
          saveMark={this.props.saveMark}
        />
      </div>
    )
  }

  static propTypes = {
    cards: PropTypes.array,
    number: PropTypes.string,
    setCardNumber: PropTypes.func.isRequired,
    expiry: PropTypes.string,
    setExpiry: PropTypes.func.isRequired,
    cvc: PropTypes.string,
    setCVC: PropTypes.func.isRequired,
    cardholderName: PropTypes.string,
    setCardholderName: PropTypes.func.isRequired,
    documentTypes: PropTypes.array,
    documentType: PropTypes.string,
    setDocumentType: PropTypes.func.isRequired,
    documentNumber: PropTypes.string,
    setDocumentNumber: PropTypes.func.isRequired,
    add: PropTypes.func.isRequired,
    saveAdd: PropTypes.func.isRequired,
    closeAddDialog: PropTypes.func.isRequired,
    addDialogShow: PropTypes.bool,
    remove: PropTypes.func.isRequired,
    saveRemove: PropTypes.func.isRequired,
    closeRemoveDialog: PropTypes.func.isRequired,
    removeDialogShow: PropTypes.bool,
    mark: PropTypes.func.isRequired,
    saveMark: PropTypes.func.isRequired,
    closeMarkDialog: PropTypes.func.isRequired,
    markDialogShow: PropTypes.bool,
    isSaving: PropTypes.bool,
    isFetching: PropTypes.bool,
    error: PropTypes.string,
  }
}

const AddDialog = ({show, closeDialog, handleNumberChange, handleExpiryChange, handleCVVChange, handleNameChange, handleDocumentTypeChange, handleDocumentNumberChange, documentTypes, saveAdd, isSaving, type}) => {
  return (
    <Dialog open={show} onClose={() => closeDialog()} maxWidth="xs" fullWidth>
      <form>
        <DialogTitle>{text.addDialog.title}</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} style={{paddingLeft: 0, paddingRight: 0}}>
              <CardNumberInput onChange={(v, e, t) => handleNumberChange(v, t)} autoFocus={true}/>
            </Grid>
            <Grid item xs={6} style={{padding: 0}}>
              <CardExpiryInput onChange={(m, y) => handleExpiryChange(m, y)} margin="dense"/>
            </Grid>
            <Grid item xs={6} style={{padding: 0}}>
              <CardCVCInput onChange={(v) => handleCVVChange(v)} margin="dense" type={type}/>
            </Grid>
            <Grid item xs={12} style={{padding: 0}}>
              <CardholderNameInput onChange={(v) => handleNameChange(v)} margin="dense"/>
            </Grid>
            <Grid item xs={12} style={{padding: 0}}>
              <DocumentTypeSelector onChange={(v) => handleDocumentTypeChange(v)} margin="dense" options={
                documentTypes.map(t => ({
                  label: t.name,
                  value: t.id,
                }))
              }/>
            </Grid>
            <Grid item xs={12} style={{padding: 0}}>
              <DocumentNumberInput onChange={(v) => handleDocumentNumberChange(v)} margin="dense"/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>{text.addDialog.cancel}</Button>
          <LoadingButton
            color="primary"
            type="submit"
            isLoading={isSaving}
            onClick={e => {
              e.preventDefault()
              saveAdd(type)
            }}
          >
            {text.addDialog.accept}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

const RemoveDialog = ({show, closeDialog, selected, isSaving, saveRemove}) => {
  const renderItemText = (digits, type) => {
    return <div>{`•••• •••• •••• ${digits}`} ({type})</div>
  }
  return (
    <Dialog open={show} onClose={() => closeDialog()}>
      <DialogTitle>{text.removeDialog.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text.removeDialog.areYouSure}</DialogContentText>
        <ListItem dense>
          <CardIcon type={selected.Type}/>
          <ListItemText primary={renderItemText(selected.LastDigits, selected.Type)}/>
        </ListItem>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => closeDialog()}>
          {text.removeDialog.cancel}
        </Button>
        <LoadingButton
          color="primary"
          isLoading={isSaving}
          onClick={() => saveRemove(selected.ID)}
        >
          {text.removeDialog.accept}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

class MarkCardAsMainDialog extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selected: props.initial,
    }
  }

  renderItemText = (digits, type) => {
    return <div>{`•••• •••• •••• ${digits}`} ({type})</div>
  }

  render() {
    const {show, closeDialog, cards, isSaving, saveMark} = this.props
    return (
      <Dialog open={show} onClose={() => closeDialog()}>
        <DialogTitle>{text.markDialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{text.markDialog.body}</DialogContentText>
          <Select
            value={this.state.selected}
            onChange={e => this.setState({selected: e.target.value})}
            fullWidth={true}
          >
            {cards.map(c => (
              <MenuItem key={c.ID} value={c.ID}><ListItemText
                primary={this.renderItemText(c.LastDigits, c.Type)}/></MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>{text.markDialog.cancel}</Button>
          <LoadingButton
            color="primary"
            isLoading={isSaving}
            onClick={() => saveMark(this.state.selected)}
          >
            {text.markDialog.accept}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    )
  }


  static propTypes = {
    show: PropTypes.bool,
    closeDialog: PropTypes.func,
    cards: PropTypes.array,
    initial: PropTypes.number,
    isSaving: PropTypes.bool,
    saveMark: PropTypes.func,
  }
}

export default withStyles(styles, {withTheme: true})(PaymentMethod)



// WEBPACK FOOTER //
// ./src/sections/profile/components/paymentMethod.js